import React, { createRef } from "react";
import { observer, inject } from "mobx-react";
import { Modal, Row, Col, Form, Button, Table } from "react-bootstrap";
import { SearchHistoryStore, SearchRequest } from "../../../../stores";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { STORE_SEARCH_HISTORY } from "../../../../constants";
import { formatDate } from "../../../../common/Formatting";
import { TableFooterPager } from "../../../../common/UI/TableFooterPager";
registerLocale('ru', ru)

interface IProps {
    isOpened: boolean;
    onClose: () => void;
    source: string;
    searchCallback: (brand: string, article: string, brandGroupId: number, articleId: number) => void;
}

interface IState {
    page: number;
    totalItemsCount: number;
    positions: SearchRequest[];
    dateFrom?: Date;
    dateTo?: Date;
}

@observer
@inject(STORE_SEARCH_HISTORY)
export class SearchHistoryModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            totalItemsCount: 0,
            positions: []
        }

    }

    private articleTextEditRef = createRef<any>();
    private searchHistoryStore = (this.props as any)[STORE_SEARCH_HISTORY] as SearchHistoryStore;

    componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {
        if (!prevProps.isOpened && this.props.isOpened)
            this.handleSearch();
    }

    private handleSearch = (page?: number) => {
        this.searchHistoryStore.loadSearchHistory([], page || this.state.page, this.props.source, this.state.dateFrom, this.state.dateTo, (positions: SearchRequest[], page: number, totalItemsCount: number) => {
            this.setState({
                positions,
                page,
                totalItemsCount
            })
        })
    }


    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.onClose} size="lg" >
            <Modal.Header closeButton>
                <Modal.Title>
                    История поиска
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col sm={12}>
                        <Form inline onSubmit={(e: any) => {
                            e.preventDefault();
                        }}>
                            <Form.Group controlId="filterForm.DateFrom">
                                <Form.Label>Дата с</Form.Label>
                                <div style={{ padding: "0px 10px" }}>
                                    <DatePicker
                                        className="form-control form-control-sm"
                                        locale="ru"
                                        dateFormat="dd-MM-yyyy"
                                        monthsShown={2}
                                        openToDate={(new Date()).addMonth(-1)}
                                        name="dateFrom"
                                        autoComplete="off"
                                        onChange={(date: Date | null) => {
                                            this.setState({
                                                dateFrom: date != null ? date : undefined
                                            })
                                        }}
                                        selected={this.state.dateFrom}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="filterForm.DateFrom">
                                <Form.Label>Дата по</Form.Label>
                                <div style={{ padding: "0px 10px" }}>
                                    <DatePicker
                                        className="form-control form-control-sm"
                                        locale="ru"
                                        dateFormat="dd-MM-yyyy"
                                        monthsShown={2}
                                        openToDate={new Date()}
                                        name="dateTo"
                                        autoComplete="off"
                                        onChange={(date: Date | null) => {
                                            this.setState({
                                                dateTo: date != null ? date : undefined
                                            })
                                        }}
                                        selected={this.state.dateTo}
                                    />
                                </div>
                            </Form.Group>
                            <Button size="sm" type="submit" onClick={() => this.handleSearch()}><FontAwesomeIcon icon='search' />{' '}Поиск</Button>

                        </Form>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col sm={12} style={{ minHeight: "200px" }}>
                        <Table bordered className="table-xxs">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Бренд</th>
                                    <th className="text-center">Артикул</th>
                                    <th className="text-center">Дата</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.positions.map((item, index) => <tr key={index}>
                                    <td className="text-center">{index + (this.state.page * 40 - 40) + 1}</td>
                                    <td className="text-center">{item.brand}</td>
                                    <td className="text-center">{item.article}</td>
                                    <td className="text-center">{formatDate(item.date)}</td>
                                    <td className="text-center"><Button className="btn-xs" onClick={() => this.props.searchCallback(item.brand, item.article, item.brandGroupId, item.articleId)}>Поиск</Button></td>
                                </tr>)}
                            </tbody>
                            <TableFooterPager
                                columnsCount={5}
                                page={this.state.page}
                                totalCount={this.state.totalItemsCount}
                                pageSize={40}
                                move={(page: number) => {
                                    this.handleSearch(page);
                                }}
                            />
                        </Table>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    }
}